module.exports = __webpack_public_path__ + "img/BGMain8.5e90c22c.jpg";